import { z } from 'zod'

export const schema = z.record(z.string(), z.string())

export const empty = Object.freeze(schema.parse({}))

export interface FirestoreCSVHeaders extends z.infer<typeof schema> {}
